import {agendaDirectory} from "../access/patientDirectory";
import {
    getDeviceTimeZone,
    localizeScheduleEntry
} from "../utils/timezone";
import {
    addDoc,
    collection,
    onSnapshot,
    query,
    orderBy,
} from "../access/firestore";

import {
    getDownloadURL,
    ref,
    uploadBytes
} from "firebase/storage";

import {
    useEffect,
    useState,
    useRef
} from "react";

import {
    db,
    storage
} from "../firebase";

import {
    sendFileToWhatsApp,
    sendWhatsAppVPS
} from "../services/whatsappVPS";
import { createRecordingFile } from "./audioRecording";
import {
    WhatsAppThread
} from "../whatsapp/WhatsAppMessageBubble";

import {
    ArrowLeft,
    CalendarDays,
    Check,
    CheckCheck,
    CircleDollarSign,
    Download,
    FileText,
    Image,
    LoaderCircle,
    Mic,
    Paperclip,
    Play,
    Send,
    Smile,
    Square,
    X
} from "lucide-react";

import {
    useClinic
} from "../context/ClinicContext";

export default function
MobileChat({

    conversation,

    onBack,

    onOpenPatient

}) {

    const {
        clinicId
    } = useClinic();
    const deviceTimeZone = getDeviceTimeZone();

    const messagesEndRef =
        useRef(null);

    const [
        messages,
        setMessages
    ] = useState([]);

    const [
        messagesLoading,
        setMessagesLoading
    ] = useState(true);

    const [
        patientSummary,
        setPatientSummary
    ] = useState({

        nextAppointment:
            null,

        balance:
            0,

        lastTreatment:
            "-"

    });

    useEffect(() => {

        if (
            !clinicId ||
            !conversation?.id
        ) {

            setMessages([]);

            setMessagesLoading(
                false
            );

            return;

        }

        setMessages([]);

        setMessagesLoading(
            true
        );

        const q = query(

            collection(

                db,

                "clinics",

                clinicId,

                "whatsappConversations",

                conversation.id,

                "messages"

            ),

            orderBy(
                "timestamp",
                "asc"
            )

        );

        return onSnapshot(

            q,

            snapshot => {

                setMessages(

                    snapshot.docs.map(
                        doc => ({

                            id:
                                doc.id,

                            ...doc.data()

                        })
                    )

                );

                setMessagesLoading(
                    false
                );

            },

            () => {

                setMessagesLoading(
                    false
                );

            }

        );

    }, [
        clinicId,
        conversation?.id
    ]);

    useEffect(() => {

        messagesEndRef.current
            ?.scrollIntoView({

                behavior:
                    "smooth"

            });

    }, [
        messages
    ]);

    useEffect(() => {

        if (
            !clinicId ||
            !conversation?.patientId
        ) {

            return;

        }

        return onSnapshot(

            agendaDirectory(db,clinicId),

            snap => {

                const citas =

                    snap.docs.map(
                        doc => localizeScheduleEntry({

                            id:
                                doc.id,

                            ...doc.data()

                        }, deviceTimeZone)
                    )

                    .filter(
                        cita =>

                            cita.pacienteId ===
                            conversation.patientId
                    );

                const saldoTotal =
                    citas.reduce(

                        (
                            acc,
                            cita
                        ) => {

                            return (

                                acc +

                                Number(
                                    cita.saldo || 0
                                )

                            );

                        },

                        0

                    );

                const proximaCita =

                    citas

                        .filter(
                            cita => {

                                const fecha =

                                    new Date(

                                        `${cita.fecha}T${cita.hora}`

                                    );

                                return (
                                    fecha >=
                                    new Date()
                                );

                            }
                        )

                        .sort(
                            (a, b) =>

                                new Date(
                                    `${a.fecha}T${a.hora}`
                                )

                                -

                                new Date(
                                    `${b.fecha}T${b.hora}`
                                )
                        )[0];

                const ultimaCita =

                    citas

                        .filter(
                            cita =>

                                cita.estado !==
                                "cancelada"
                        )

                        .sort(
                            (a, b) =>

                                new Date(
                                    `${b.fecha}T${b.hora}`
                                )

                                -

                                new Date(
                                    `${a.fecha}T${a.hora}`
                                )
                        )[0];

                setPatientSummary({

                    nextAppointment:
                        proximaCita,

                    balance:
                        saldoTotal,

                    lastTreatment:

                        ultimaCita?.motivo

                        ||

                        "-"

                });

            }

        );

    }, [
        clinicId,
        conversation,
        deviceTimeZone
    ]);

    const formatearHora =
        timestamp => {

            if (!timestamp)
                return "";

            const fecha =

                timestamp.toDate
                    ? timestamp.toDate()
                    : new Date(
                        timestamp
                    );

            return fecha
                .toLocaleTimeString(
                    "es-MX",
                    {

                        hour:
                            "numeric",

                        minute:
                            "2-digit",

                        hour12:
                            true

                    }
                );

    };

    const [
        newMessage,
        setNewMessage
    ] = useState("");

    const [
        sending,
        setSending
    ] = useState(false);

    const fileInputRef =
        useRef(null);

    const audioInputRef =
        useRef(null);

    const [
        selectedFile,
        setSelectedFile
    ] = useState(null);

    const [
        sendingFile,
        setSendingFile
    ] = useState(false);

    const [
        showEmojiPicker,
        setShowEmojiPicker
    ] = useState(false);

    const [
        showAttachmentMenu,
        setShowAttachmentMenu
    ] = useState(false);

    const [
        isRecording,
        setIsRecording
    ] = useState(false);

    const [
        recordingSeconds,
        setRecordingSeconds
    ] = useState(0);

    const [
        recordedAudio,
        setRecordedAudio
    ] = useState(null);

    const [
        recordedAudioUrl,
        setRecordedAudioUrl
    ] = useState("");

    const mediaRecorderRef =
        useRef(null);
    const recordingStreamRef = useRef(null);
    const startingRecordingRef = useRef(false);
    const chatMountedRef = useRef(true);

    const audioChunksRef =
        useRef([]);

    const recordingTimerRef =
        useRef(null);

    const emojiList = [
        "😀",
        "😂",
        "😍",
        "😊",
        "😉",
        "😎",
        "🥰",
        "😘",
        "🤗",
        "👍",
        "👏",
        "🙏",
        "❤️",
        "💙",
        "💚",
        "🎉",
        "✨",
        "🔥",
        "😁",
        "😅",
        "😢",
        "😮",
        "😡",
        "🤔",
        "🦷",
        "🪥",
        "😁",
        "😷"
    ];

    const profilePhoto =
        conversation?.profilePicUrl ||
        conversation?.profilePhoto ||
        conversation?.photoURL ||
        conversation?.photoUrl ||
        conversation?.profilePicture ||
        "";

    const patientName =
        conversation?.patientName ||
        conversation?.name ||
        "Prospecto";

    function obtenerIniciales(
        nombre
    ) {

        const partes =
            String(nombre || "P")
                .trim()
                .split(/\s+/);

        if (
            partes.length === 1
        ) {

            return partes[0]
                .slice(0, 2)
                .toUpperCase();

        }

        return (
            partes[0]?.[0] || ""
        ) + (
            partes[partes.length - 1]?.[0] || ""
        );

    }

    function insertarEmoji(
        emoji
    ) {

        setNewMessage(
            current =>
                `${current}${emoji}`
        );

        setShowEmojiPicker(false);

    }

    function handleFileSelected(
        event
    ) {

        const file =
            event.target.files?.[0];

        if (!file) {
            return;
        }

        setSelectedFile(file);
        setShowEmojiPicker(false);

    }

    function openAttachmentPicker(accept) {

        if (fileInputRef.current) {
            fileInputRef.current.accept = accept;
            fileInputRef.current.click();
        }

        setShowAttachmentMenu(false);
        setShowEmojiPicker(false);

    }

    async function handleSendFile(
        fileToSend = selectedFile
    ) {

        if (
            !fileToSend ||
            !conversation ||
            sendingFile
        ) {
            return false;
        }

        const phone = String(
            conversation.whatsapp ||
            conversation.id ||
            ""
        )
            .replace("@c.us", "")
            .replace(/\D/g, "");

        if (!/^\d{8,15}$/.test(phone)) {

            alert(
                "No se encontró el número de WhatsApp de la conversación."
            );

            return false;

        }

        setSendingFile(true);

        try {

            const response =
                await sendFileToWhatsApp({

                    clinicId,

                    phone,

                    file:
                        fileToSend,

                    caption:
                        "",

                    conversationId:
                        conversation.id,

                    patientId:
                        conversation.patientId,

                    db,

                    storage,

                    collection,

                    addDoc,

                    ref,

                    uploadBytes,

                    getDownloadURL

                });

            if (
                !response ||
                !response.result ||
                !response.result.success
            ) {

                throw new Error(
                    response?.result?.error ||
                    "No se pudo enviar el archivo por WhatsApp."
                );

            }

            setSelectedFile(
                null
            );

            if (
                fileInputRef.current
            ) {

                fileInputRef.current.value =
                    "";

            }

            if (
                audioInputRef.current
            ) {

                audioInputRef.current.value =
                    "";

            }

            return true;

        } catch (error) {

            alert(
                error?.message ||
                "No se pudo enviar el archivo."
            );

            return false;

        } finally {

            setSendingFile(
                false
            );

        }

    }

    function detenerGrabacionTimer() {

        if (
            recordingTimerRef.current
        ) {

            clearInterval(
                recordingTimerRef.current
            );

            recordingTimerRef.current =
                null;

        }

    }

    async function iniciarGrabacion() {

        if (
            isRecording ||
            startingRecordingRef.current ||
            sendingFile ||
            recordedAudio
        ) {
            return;
        }

        if (
            typeof MediaRecorder ===
            "undefined"
        ) {

            alert(
                "Este dispositivo no permite grabar audio desde el navegador."
            );

            return;
        }

        startingRecordingRef.current = true;
        try {

            const stream =
                await navigator.mediaDevices
                    .getUserMedia({
                        audio: true
                    });

            if (!chatMountedRef.current) {
                stream.getTracks().forEach(track => track.stop());
                return;
            }
            recordingStreamRef.current = stream;

            const tiposAudio = [
                "audio/webm;codecs=opus",
                "audio/webm",
                "audio/mp4",
                "audio/ogg;codecs=opus"
            ];

            const tipoSoportado =
                tiposAudio.find(
                    tipo =>
                        MediaRecorder.isTypeSupported(
                            tipo
                        )
                );

            const recorder =
                tipoSoportado
                    ?
                    new MediaRecorder(
                        stream,
                        {
                            mimeType:
                                tipoSoportado
                        }
                    )
                    :
                    new MediaRecorder(
                        stream
                    );

            audioChunksRef.current =
                [];

            recorder.ondataavailable =
                event => {

                    if (
                        event.data &&
                        event.data.size > 0
                    ) {

                        audioChunksRef.current.push(
                            event.data
                        );

                    }

                };

            recorder.onstop =
                () => {

                    detenerGrabacionTimer();

                    stream.getTracks().forEach(track => track.stop());
                    recordingStreamRef.current = null;
                    mediaRecorderRef.current = null;
                    if (!chatMountedRef.current) return;

                    const audioFile = createRecordingFile(
                        audioChunksRef.current,
                        recorder.mimeType || tipoSoportado
                    );

                    setIsRecording(
                        false
                    );

                    setRecordingSeconds(
                        0
                    );

                    if (
                        audioFile.size === 0
                    ) {

                        audioChunksRef.current =
                            [];

                        return;
                    }

                    const audioUrl =
                        URL.createObjectURL(
                            audioFile
                        );

                    setRecordedAudio(
                        audioFile
                    );

                    setRecordedAudioUrl(
                        audioUrl
                    );

                    audioChunksRef.current =
                        [];

                };

            mediaRecorderRef.current =
                recorder;

            recorder.start();

            setIsRecording(
                true
            );

            setRecordingSeconds(
                0
            );

            recordingTimerRef.current =
                setInterval(
                    () => {

                        setRecordingSeconds(
                            seconds =>
                                seconds + 1
                        );

                    },
                    1000
                );

        } catch (error) {

            recordingStreamRef.current?.getTracks().forEach(track => track.stop());
            recordingStreamRef.current = null;
            mediaRecorderRef.current = null;
            detenerGrabacionTimer();
            alert(
                "No se pudo iniciar la grabación de audio."
            );
        } finally {
            startingRecordingRef.current = false;
        }

    }

    function detenerGrabacion() {

        const recorder =
            mediaRecorderRef.current;

        if (
            !recorder ||
            recorder.state ===
                "inactive"
        ) {
            return;
        }

        recorder.stop();

    }

    function cancelarGrabacion() {

        const recorder =
            mediaRecorderRef.current;

        detenerGrabacionTimer();

        if (
            recorder &&
            recorder.state !==
                "inactive"
        ) {

            recorder.ondataavailable =
                null;

            recorder.onstop =
                () => {

                    recorder.stream
                        .getTracks()
                        .forEach(
                            track =>
                                track.stop()
                        );

                };

            recorder.stop();

        }

        mediaRecorderRef.current =
            null;
        recordingStreamRef.current?.getTracks().forEach(track => track.stop());
        recordingStreamRef.current = null;

        audioChunksRef.current =
            [];

        setIsRecording(
            false
        );

        setRecordingSeconds(
            0
        );

    }

    useEffect(() => {

        chatMountedRef.current = true;
        return () => {

            chatMountedRef.current = false;
            detenerGrabacionTimer();

            const recorder =
                mediaRecorderRef.current;

            if (
                recorder &&
                recorder.state !==
                    "inactive"
            ) {

                recorder.onstop = null;
                recorder.ondataavailable = null;
                recorder.stop();
            }
            recordingStreamRef.current?.getTracks().forEach(track => track.stop());
            recordingStreamRef.current = null;

        };

    }, []);

    useEffect(() => () => {
        if (recordedAudioUrl) URL.revokeObjectURL(recordedAudioUrl);
    }, [recordedAudioUrl]);

    function cancelarAudioPreparado() {

        setRecordedAudio(
            null
        );

        setRecordedAudioUrl(
            ""
        );

    }

    async function enviarAudioPreparado() {

        if (
            !recordedAudio ||
            sendingFile
        ) {
            return;
        }

        const enviado =
            await handleSendFile(
                recordedAudio
            );

        if (
            enviado
        ) {

            setRecordedAudio(
                null
            );

            setRecordedAudioUrl(
                ""
            );

        }

    }

    async function handleSendMessage() {

        if (
            !newMessage.trim() ||
            !conversation ||
            sending
        ) {
            return;
        }

        const phone = String(
            conversation.whatsapp ||
            conversation.id ||
            ""
        )
        .replace("@c.us", "")
        .replace(/\D/g, "");

        if (!/^\d{8,15}$/.test(phone)) {
            alert("No se encontró un número de WhatsApp válido para esta conversación.");
            return;
        }

        setSending(true);

        try {
            const result =
            await sendWhatsAppVPS(

                clinicId,

                phone,

                newMessage,

                conversation.patientId,

                conversation.patientName

            );

            if (result?.success) {

                setNewMessage("");

            } else {

                alert(result?.error || "No se pudo enviar el mensaje.");

            }
        } catch (error) {
            alert(error?.message || "No se pudo enviar el mensaje.");
        } finally {
            setSending(false);
        }
    };

    return (

    <div className="vd-mobile-whatsapp vd-mobile-chat"
        style={{
            minHeight:
                "100vh",
            background:
                "#f3f4f6",
            boxSizing:
                "border-box",
            paddingTop:
                142,
            paddingBottom:
                "calc(118px + env(safe-area-inset-bottom))"
        }}
    >

        <div
            style={{
                position:
                    "fixed",
                top:
                    "calc(72px + env(safe-area-inset-top))",
                left:
                    12,
                right:
                    12,
                zIndex:
                    100,
                background:
                    "rgba(255,255,255,0.97)",
                backdropFilter:
                    "blur(18px)",
                WebkitBackdropFilter:
                    "blur(18px)",
                border:
                    "1px solid rgba(226,232,240,0.9)",
                borderRadius:
                    18,
                boxShadow:
                    "0 6px 24px rgba(15,23,42,0.08)",
                overflow:
                    "hidden"
            }}
        >

            <div
                style={{
                    display:
                        "flex",
                    alignItems:
                        "center",
                    gap:
                        10,
                    padding:
                        "10px 12px 8px"
                }}
            >

                <button
                    type="button"
                    onClick={
                        onBack
                    }
                    style={{
                        width:
                            38,
                        height:
                            38,
                        border:
                            "none",
                        borderRadius:
                            12,
                        background:
                            "#f1f5f9",
                        color:
                            "#334155",
                        display:
                            "flex",
                        alignItems:
                            "center",
                        justifyContent:
                            "center",
                        flexShrink:
                            0,
                        cursor:
                            "pointer"
                    }}
                >
                    <ArrowLeft
                        size={20}
                        strokeWidth={2}
                    />
                </button>

                <div
                    style={{
                        width:
                            42,
                        height:
                            42,
                        borderRadius:
                            "50%",
                        overflow:
                            "hidden",
                        background:
                            "#e2e8f0",
                        color:
                            "#475569",
                        display:
                            "flex",
                        alignItems:
                            "center",
                        justifyContent:
                            "center",
                        flexShrink:
                            0,
                        fontSize:
                            14,
                        fontWeight:
                            800
                    }}
                >

                    {profilePhoto ? (

                        <img
                            src={
                                profilePhoto
                            }
                            alt=""
                            style={{
                                width:
                                    "100%",
                                height:
                                    "100%",
                                objectFit:
                                    "cover"
                            }}
                        />

                    ) : (

                        obtenerIniciales(
                            patientName
                        )

                    )}

                </div>

                <div
                    onClick={() => {

                        if (
                            conversation
                                ?.patientId &&
                            onOpenPatient
                        ) {

                            onOpenPatient({

                                id:
                                    conversation
                                        .patientId,

                                nombre:
                                    conversation
                                        .patientName

                            });

                        }

                    }}
                    style={{
                        minWidth:
                            0,
                        flex:
                            1,
                        cursor:
                            conversation
                                ?.patientId
                                ?
                                "pointer"
                                :
                                "default"
                    }}
                >

                    <div
                        style={{
                            fontSize:
                                16,
                            fontWeight:
                                700,
                            color:
                                "#0f172a",
                            whiteSpace:
                                "nowrap",
                            overflow:
                                "hidden",
                            textOverflow:
                                "ellipsis"
                        }}
                    >
                        {
                            patientName
                        }
                    </div>

                    <div
                        style={{
                            marginTop:
                                2,
                            fontSize:
                                12,
                            color:
                                "#64748b"
                        }}
                    >
                        WhatsApp
                    </div>

                </div>

            </div>

            <div
                style={{
                    display:
                        "grid",
                    gridTemplateColumns:
                        "1fr 1fr 1fr",
                    borderTop:
                        "1px solid #f1f5f9",
                    background:
                        "#f8fafc"
                }}
            >

                <div
                    style={{
                        padding:
                            "8px 6px",
                        textAlign:
                            "center",
                        borderRight:
                            "1px solid #e2e8f0"
                    }}
                >

                    <CalendarDays
                        size={15}
                        strokeWidth={1.8}
                        style={{
                            color:
                                "#64748b",
                            margin:
                                "0 auto 3px"
                        }}
                    />

                    <div
                        style={{
                            fontSize:
                                11,
                            color:
                                "#64748b"
                        }}
                    >
                        Próxima cita
                    </div>

                    <div
                        style={{
                            marginTop:
                                2,
                            fontSize:
                                12,
                            fontWeight:
                                700,
                            color:
                                "#0f172a",
                            whiteSpace:
                                "nowrap",
                            overflow:
                                "hidden",
                            textOverflow:
                                "ellipsis"
                        }}
                    >
                        {
                            patientSummary
                                .nextAppointment
                                ?
                                `${patientSummary.nextAppointment.fecha} ${patientSummary.nextAppointment.hora}`
                                :
                                "-"
                        }
                    </div>

                </div>

                <div
                    style={{
                        padding:
                            "8px 6px",
                        textAlign:
                            "center",
                        borderRight:
                            "1px solid #e2e8f0"
                    }}
                >

                    <CircleDollarSign
                        size={15}
                        strokeWidth={1.8}
                        style={{
                            color:
                                "#64748b",
                            margin:
                                "0 auto 3px"
                        }}
                    />

                    <div
                        style={{
                            fontSize:
                                11,
                            color:
                                "#64748b"
                        }}
                    >
                        Saldo
                    </div>

                    <div
                        style={{
                            marginTop:
                                2,
                            fontSize:
                                12,
                            fontWeight:
                                700,
                            color:
                                "#0f172a"
                        }}
                    >
                        $
                        {
                            patientSummary
                                .balance
                                .toLocaleString()
                        }
                    </div>

                </div>

                <div
                    style={{
                        padding:
                            "8px 6px",
                        textAlign:
                            "center"
                    }}
                >

                    <div
                        style={{
                            fontSize:
                                11,
                            color:
                                "#64748b",
                            marginTop:
                                1
                        }}
                    >
                        Último tratamiento
                    </div>

                    <div
                        style={{
                            marginTop:
                                4,
                            fontSize:
                                12,
                            fontWeight:
                                700,
                            color:
                                "#0f172a",
                            whiteSpace:
                                "nowrap",
                            overflow:
                                "hidden",
                            textOverflow:
                                "ellipsis"
                        }}
                    >
                        {
                            patientSummary
                                .lastTreatment
                        }
                    </div>

                </div>

            </div>

        </div>

        <div
            style={{
                padding:
                    "0 12px"
            }}
        >

            <WhatsAppThread
                messages={messages}
                compact
                onOpenFile={(url, filename, mimeType) => {
                    window.open(url, "_blank", "noopener,noreferrer");
                }}
                bottomRef={messagesEndRef}
            />

            <div style={{display:"none"}} aria-hidden="true">

            {
                messagesLoading
                    ?
                    (
                        <div
                            style={{
                                minHeight:
                                    280,
                                display:
                                    "flex",
                                alignItems:
                                    "center",
                                justifyContent:
                                    "center",
                                color:
                                    "#94a3b8",
                                fontSize:
                                    14
                            }}
                        >
                            Cargando mensajes...
                        </div>
                    )
                    :
                    messages.map(
                        message => {

                            const isFile =
                                message.type ===
                                "file";

                            const mimeType =
                                message.mimeType ||
                                "";

                            const isImage =
                                mimeType.startsWith(
                                    "image/"
                                );

                            const isAudio =
                                mimeType.startsWith(
                                    "audio/"
                                );

                            const isSending =
                                message.status ===
                                "sending";

                            const isRead =
                                message.status ===
                                    "read" ||
                                message.status ===
                                    "seen";

                            const isDelivered =
                                message.status ===
                                    "delivered";

                            return (

                                <div
                                    key={
                                        message.id
                                    }
                                    style={{
                                        display:
                                            "flex",
                                        justifyContent:
                                            message.fromMe
                                                ?
                                                "flex-end"
                                                :
                                                "flex-start",
                                        marginBottom:
                                            7
                                    }}
                                >

                                    <div
                                        style={{
                                            maxWidth:
                                                "82%",
                                            background:
                                                message.fromMe
                                                    ?
                                                    "#d9fdd3"
                                                    :
                                                    "#ffffff",
                                            borderRadius:
                                                message.fromMe
                                                    ?
                                                    "16px 16px 4px 16px"
                                                    :
                                                    "16px 16px 16px 4px",
                                            padding:
                                                "7px 8px 6px",
                                            boxShadow:
                                                "0 1px 2px rgba(15,23,42,0.08)",
                                            border:
                                                "1px solid rgba(226,232,240,0.7)",
                                            wordBreak:
                                                "break-word"
                                        }}
                                    >

                                        {
                                            isFile &&
                                            isImage &&
                                            message.fileUrl
                                                ?
                                                (
                                                    <a
                                                        href={
                                                            message.fileUrl
                                                        }
                                                        target="_blank"
                                                        rel="noreferrer"
                                                        style={{
                                                            display:
                                                                "block",
                                                            textDecoration:
                                                                "none"
                                                        }}
                                                    >
                                                        <img
                                                            src={
                                                                message.fileUrl
                                                            }
                                                            alt={
                                                                message.filename ||
                                                                "Imagen"
                                                            }
                                                            style={{
                                                                display:
                                                                    "block",
                                                                width:
                                                                    "100%",
                                                                maxWidth:
                                                                    280,
                                                                maxHeight:
                                                                    320,
                                                                objectFit:
                                                                    "cover",
                                                                borderRadius:
                                                                    12
                                                            }}
                                                        />
                                                    </a>
                                                )
                                                :
                                                null
                                        }

                                        {
                                            isFile &&
                                            isAudio &&
                                            message.fileUrl
                                                ?
                                                (
                                                    <div
                                                        style={{
                                                            display:
                                                                "flex",
                                                            alignItems:
                                                                "center",
                                                            gap:
                                                                8,
                                                            minWidth:
                                                                220,
                                                            padding:
                                                                "5px 2px"
                                                        }}
                                                    >
                                                        <Play
                                                            size={18}
                                                            strokeWidth={2}
                                                        />

                                                        <audio
                                                            controls
                                                            src={
                                                                message.fileUrl
                                                            }
                                                            style={{
                                                                width:
                                                                    220,
                                                                maxWidth:
                                                                    "100%"
                                                            }}
                                                        />
                                                    </div>
                                                )
                                                :
                                                null
                                        }

                                        {
                                            isFile &&
                                            !isImage &&
                                            !isAudio
                                                ?
                                                (
                                                    <a
                                                        href={
                                                            message.fileUrl
                                                        }
                                                        target="_blank"
                                                        rel="noreferrer"
                                                        download
                                                        style={{
                                                            display:
                                                                "flex",
                                                            alignItems:
                                                                "center",
                                                            gap:
                                                                10,
                                                            minWidth:
                                                                190,
                                                            padding:
                                                                "7px 5px",
                                                            color:
                                                                "#0f172a",
                                                            textDecoration:
                                                                "none"
                                                        }}
                                                    >
                                                        <FileText
                                                            size={24}
                                                            strokeWidth={1.8}
                                                        />

                                                        <span
                                                            style={{
                                                                flex:
                                                                    1,
                                                                minWidth:
                                                                    0,
                                                                fontSize:
                                                                    13,
                                                                fontWeight:
                                                                    700,
                                                                overflow:
                                                                    "hidden",
                                                                textOverflow:
                                                                    "ellipsis",
                                                                whiteSpace:
                                                                    "nowrap"
                                                            }}
                                                        >
                                                            {
                                                                message.filename ||
                                                                "Documento"
                                                            }
                                                        </span>

                                                        <Download
                                                            size={18}
                                                            strokeWidth={1.8}
                                                        />
                                                    </a>
                                                )
                                                :
                                                null
                                        }

                                        {
                                            isFile &&
                                            message.caption
                                                ?
                                                (
                                                    <div
                                                        style={{
                                                            marginTop:
                                                                5,
                                                            padding:
                                                                "0 4px",
                                                            fontSize:
                                                                14,
                                                            lineHeight:
                                                                1.4,
                                                            color:
                                                                "#172033"
                                                        }}
                                                    >
                                                        {
                                                            message.caption
                                                        }
                                                    </div>
                                                )
                                                :
                                                null
                                        }

                                        {
                                            !isFile
                                                ?
                                                (
                                                    <div
                                                        style={{
                                                            padding:
                                                                "2px 3px 0",
                                                            fontSize:
                                                                15,
                                                            lineHeight:
                                                                1.42,
                                                            color:
                                                                "#172033",
                                                            whiteSpace:
                                                                "pre-wrap"
                                                        }}
                                                    >
                                                        {
                                                            message.body ||
                                                            "Mensaje vacío"
                                                        }
                                                    </div>
                                                )
                                                :
                                                null
                                        }

                                        <div
                                            style={{
                                                marginTop:
                                                    4,
                                                padding:
                                                    "0 3px",
                                                display:
                                                    "flex",
                                                justifyContent:
                                                    "flex-end",
                                                alignItems:
                                                    "center",
                                                gap:
                                                    4,
                                                fontSize:
                                                    10.5,
                                                color:
                                                    "#64748b"
                                            }}
                                        >

                                            {
                                                formatearHora(
                                                    message.timestamp
                                                )
                                            }

                                            {
                                                message.fromMe
                                                    ?
                                                    (
                                                        isSending
                                                            ?
                                                            (
                                                                <LoaderCircle
                                                                    size={12}
                                                                    strokeWidth={2}
                                                                    style={{
                                                                        animation:
                                                                            "spin 1s linear infinite"
                                                                    }}
                                                                />
                                                            )
                                                            :
                                                            isRead
                                                                ?
                                                                (
                                                                    <CheckCheck
                                                                        size={14}
                                                                        strokeWidth={2}
                                                                        style={{
                                                                            color:
                                                                                "#2563eb"
                                                                        }}
                                                                    />
                                                                )
                                                                :
                                                                isDelivered
                                                                    ?
                                                                    (
                                                                        <CheckCheck
                                                                            size={14}
                                                                            strokeWidth={2}
                                                                        />
                                                                    )
                                                                    :
                                                                    (
                                                                        <Check
                                                                            size={14}
                                                                            strokeWidth={2}
                                                                        />
                                                                    )
                                                    )
                                                    :
                                                    null
                                            }

                                        </div>

                                    </div>

                                </div>

                            );

                        }
                    )
            }

        </div>

        <div
            ref={
                messagesEndRef
            }
        />

            </div>

        {
            selectedFile
                ?
                (
                    <div
                        style={{
                            position:
                                "fixed",
                            left:
                                12,
                            right:
                                12,
                            bottom:
                                "calc(158px + env(safe-area-inset-bottom))",
                            zIndex:
                                901,
                            display:
                                "flex",
                            alignItems:
                                "center",
                            gap:
                                10,
                            padding:
                                "10px 12px",
                            background:
                                "#ffffff",
                            border:
                                "1px solid #dbeafe",
                            borderRadius:
                                16,
                            boxShadow:
                                "0 8px 30px rgba(15,23,42,0.12)"
                        }}
                    >

                        {
                            selectedFile.type
                                ?.startsWith(
                                    "image/"
                                )
                                ?
                                (
                                    <Image
                                        size={20}
                                        strokeWidth={1.8}
                                    />
                                )
                                :
                                (
                                    <FileText
                                        size={20}
                                        strokeWidth={1.8}
                                    />
                                )
                        }

                        <div
                            style={{
                                flex:
                                    1,
                                minWidth:
                                    0
                            }}
                        >

                            <div
                                style={{
                                    fontSize:
                                        13,
                                    fontWeight:
                                        700,
                                    color:
                                        "#0f172a",
                                    overflow:
                                        "hidden",
                                    textOverflow:
                                        "ellipsis",
                                    whiteSpace:
                                        "nowrap"
                                }}
                            >
                                {
                                    selectedFile.name
                                }
                            </div>

                            <div
                                style={{
                                    marginTop:
                                        2,
                                    fontSize:
                                        11,
                                    color:
                                        "#64748b"
                                }}
                            >
                                {
                                    Math.max(
                                        1,
                                        Math.round(
                                            selectedFile.size /
                                            1024
                                        )
                                    )
                                } KB
                            </div>

                        </div>

                        <button
                            type="button"
                            onClick={() => {

                                setSelectedFile(
                                    null
                                );

                                if (
                                    fileInputRef.current
                                ) {

                                    fileInputRef.current.value =
                                        "";

                                }

                            }}
                            style={{
                                width:
                                    34,
                                height:
                                    34,
                                border:
                                    "none",
                                borderRadius:
                                    10,
                                background:
                                    "#f1f5f9",
                                color:
                                    "#475569",
                                display:
                                    "flex",
                                alignItems:
                                    "center",
                                justifyContent:
                                    "center"
                            }}
                        >
                            <X
                                size={18}
                                strokeWidth={2}
                            />
                        </button>

                        <button
                            type="button"
                            onClick={
                                () =>
                                    handleSendFile()
                            }
                            disabled={
                                sendingFile
                            }
                            style={{
                                width:
                                    40,
                                height:
                                    40,
                                border:
                                    "none",
                                borderRadius:
                                    12,
                                background:
                                    sendingFile
                                        ?
                                        "#cbd5e1"
                                        :
                                        "#2563eb",
                                color:
                                    "#ffffff",
                                display:
                                    "flex",
                                alignItems:
                                    "center",
                                justifyContent:
                                    "center"
                            }}
                        >
                            {
                                sendingFile
                                    ?
                                    (
                                        <LoaderCircle
                                            size={18}
                                            style={{
                                                animation:
                                                    "spin 1s linear infinite"
                                            }}
                                        />
                                    )
                                    :
                                    (
                                        <Send
                                            size={18}
                                            strokeWidth={2}
                                        />
                                    )
                            }
                        </button>

                    </div>
                )
                :
                null
        }

        {
            showEmojiPicker
                ?
                (
                    <div
                        style={{
                            position:
                                "fixed",
                            left:
                                12,
                            right:
                                12,
                            bottom:
                                "calc(158px + env(safe-area-inset-bottom))",
                            zIndex:
                                902,
                            padding:
                                12,
                            background:
                                "#ffffff",
                            border:
                                "1px solid #e2e8f0",
                            borderRadius:
                                18,
                            boxShadow:
                                "0 12px 35px rgba(15,23,42,0.14)"
                        }}
                    >

                        <div
                            style={{
                                display:
                                    "grid",
                                gridTemplateColumns:
                                    "repeat(7, 1fr)",
                                gap:
                                    8
                            }}
                        >

                            {
                                emojiList.map(
                                    (
                                        emoji,
                                        index
                                    ) => (

                                        <button
                                            key={
                                                `${emoji}-${index}`
                                            }
                                            type="button"
                                            onClick={() =>
                                                insertarEmoji(
                                                    emoji
                                                )
                                            }
                                            style={{
                                                border:
                                                    "none",
                                                background:
                                                    "transparent",
                                                fontSize:
                                                    25,
                                                lineHeight:
                                                    1,
                                                padding:
                                                    "5px 0"
                                            }}
                                        >
                                            {
                                                emoji
                                            }
                                        </button>

                                    )
                                )
                            }

                        </div>

                    </div>
                )
                :
                null
        }

        <div
            style={{
                position:
                    "fixed",
                left:
                    12,
                right:
                    12,
                bottom:
                    "calc(92px + env(safe-area-inset-bottom))",
                zIndex:
                    900,
                display:
                    "flex",
                alignItems:
                    "center",
                gap:
                    7,
                padding:
                    "8px",
                background:
                    "rgba(255,255,255,0.97)",
                backdropFilter:
                    "blur(18px)",
                WebkitBackdropFilter:
                    "blur(18px)",
                border:
                    "1px solid rgba(226,232,240,0.95)",
                borderRadius:
                    22,
                boxShadow:
                    "0 8px 30px rgba(15,23,42,0.12)",
                boxSizing:
                    "border-box"
            }}
        >

            <input
                ref={
                    fileInputRef
                }
                type="file"
                accept="image/*,.pdf,.doc,.docx,.xls,.xlsx,.txt"
                onChange={
                    handleFileSelected
                }
                style={{
                    display:
                        "none"
                }}
            />

            {
                showAttachmentMenu && (
                    <div
                        className="vd-mobile-attachment-menu"
                        role="menu"
                        aria-label="Opciones de adjunto"
                    >
                        <button
                            type="button"
                            role="menuitem"
                            onClick={() => openAttachmentPicker("image/*,video/*")}
                        >
                            <Image size={17} strokeWidth={2.2} />
                            <span>Fotos y videos</span>
                        </button>
                        <button
                            type="button"
                            role="menuitem"
                            onClick={() => openAttachmentPicker(".pdf,.doc,.docx,.xls,.xlsx,.txt")}
                        >
                            <FileText size={17} strokeWidth={2.2} />
                            <span>Documento</span>
                        </button>
                    </div>
                )
            }

            <input
                ref={
                    audioInputRef
                }
                type="file"
                accept="audio/*"
                capture="user"
                onChange={event => {

                    const file =
                        event.target.files?.[0];

                    if (
                        file
                    ) {

                        handleSendFile(
                            file
                        );

                    }

                    event.target.value =
                        "";

                }}
                style={{
                    display:
                        "none"
                }}
            />

            {
                isRecording
                    ?
                    (
                        <>
                            <button
                                type="button"
                                onClick={
                                    cancelarGrabacion
                                }
                                aria-label="Cancelar grabación"
                                style={{
                                    width:
                                        42,
                                    height:
                                        42,
                                    border:
                                        "none",
                                    borderRadius:
                                        14,
                                    background:
                                        "#fee2e2",
                                    color:
                                        "#dc2626",
                                    display:
                                        "flex",
                                    alignItems:
                                        "center",
                                    justifyContent:
                                        "center",
                                    flexShrink:
                                        0
                                }}
                            >
                                <X
                                    size={19}
                                    strokeWidth={2}
                                />
                            </button>

                            <div
                                style={{
                                    flex:
                                        1,
                                    minWidth:
                                        0,
                                    height:
                                        44,
                                    display:
                                        "flex",
                                    alignItems:
                                        "center",
                                    gap:
                                        9,
                                    padding:
                                        "0 12px",
                                    background:
                                        "#fef2f2",
                                    borderRadius:
                                        15,
                                    color:
                                        "#b91c1c",
                                    fontSize:
                                        14,
                                    fontWeight:
                                        700
                                }}
                            >

                                <span
                                    style={{
                                        width:
                                            9,
                                        height:
                                            9,
                                        borderRadius:
                                            "50%",
                                        background:
                                            "#ef4444",
                                        flexShrink:
                                            0
                                    }}
                                />

                                Grabando{" "}
                                {String(
                                    Math.floor(
                                        recordingSeconds /
                                        60
                                    )
                                ).padStart(
                                    2,
                                    "0"
                                )}
                                :
                                {String(
                                    recordingSeconds %
                                    60
                                ).padStart(
                                    2,
                                    "0"
                                )}

                            </div>

                            <button
                                type="button"
                                onClick={
                                    detenerGrabacion
                                }
                                aria-label="Detener grabación"
                                style={{
                                    width:
                                        44,
                                    height:
                                        44,
                                    border:
                                        "none",
                                    borderRadius:
                                        15,
                                    background:
                                        "#dc2626",
                                    color:
                                        "#ffffff",
                                    display:
                                        "flex",
                                    alignItems:
                                        "center",
                                    justifyContent:
                                        "center",
                                    flexShrink:
                                        0
                                }}
                            >
                                <Square
                                    size={17}
                                    fill="currentColor"
                                    strokeWidth={2}
                                />
                            </button>
                        </>
                    )
                    :
                    recordedAudio
                        ?
                        (
                            <>
                                <button
                                    type="button"
                                    onClick={
                                        cancelarAudioPreparado
                                    }
                                    aria-label="Descartar audio"
                                    disabled={
                                        sendingFile
                                    }
                                    style={{
                                        width:
                                            42,
                                        height:
                                            42,
                                        border:
                                            "none",
                                        borderRadius:
                                            14,
                                        background:
                                            "#fee2e2",
                                        color:
                                            "#dc2626",
                                        display:
                                            "flex",
                                        alignItems:
                                            "center",
                                        justifyContent:
                                            "center",
                                        flexShrink:
                                            0
                                    }}
                                >
                                    <X
                                        size={19}
                                        strokeWidth={2}
                                    />
                                </button>

                                <div
                                    style={{
                                        flex:
                                            1,
                                        minWidth:
                                            0,
                                        height:
                                            44,
                                        display:
                                            "flex",
                                        alignItems:
                                            "center",
                                        padding:
                                            "0 10px",
                                        background:
                                            "#f1f5f9",
                                        borderRadius:
                                            15
                                    }}
                                >

                                    <audio
                                        src={
                                            recordedAudioUrl
                                        }
                                        controls
                                        style={{
                                            width:
                                                "100%",
                                            height:
                                                34
                                        }}
                                    />

                                </div>

                                <button
                                    type="button"
                                    onClick={
                                        enviarAudioPreparado
                                    }
                                    aria-label="Enviar audio"
                                    disabled={
                                        sendingFile
                                    }
                                    style={{
                                        width:
                                            44,
                                        height:
                                            44,
                                        border:
                                            "none",
                                        borderRadius:
                                            15,
                                        background:
                                            sendingFile
                                                ?
                                                "#94a3b8"
                                                :
                                                "#16a34a",
                                        color:
                                            "#ffffff",
                                        display:
                                            "flex",
                                        alignItems:
                                            "center",
                                        justifyContent:
                                            "center",
                                        flexShrink:
                                            0
                                    }}
                                >

                                    {
                                        sendingFile
                                            ?
                                            (
                                                <LoaderCircle
                                                    size={19}
                                                    strokeWidth={2}
                                                    style={{
                                                        animation:
                                                            "spin 1s linear infinite"
                                                    }}
                                                />
                                            )
                                            :
                                            (
                                                <Send
                                                    size={18}
                                                    strokeWidth={2}
                                                />
                                            )
                                    }

                                </button>
                            </>
                        )
                        :
                        (
                            <>
                                <button
                                    type="button"
                                    className="vd-mobile-composer-icon vd-mobile-composer-attach"
                                    onClick={() => {

                                        setShowAttachmentMenu(
                                            current => !current
                                        );

                                        setShowEmojiPicker(
                                            false
                                        );

                                    }}
                                    disabled={
                                        sending ||
                                        sendingFile
                                    }
                                    style={{
                                        width:
                                            40,
                                        height:
                                            40,
                                        border:
                                            "none",
                                        borderRadius:
                                            13,
                                        background:
                                            "#f1f5f9",
                                        color:
                                            "#475569",
                                        display:
                                            "flex",
                                        alignItems:
                                            "center",
                                        justifyContent:
                                            "center",
                                        flexShrink:
                                            0
                                    }}
                                >
                                    <Paperclip
                                        size={18}
                                        strokeWidth={2}
                                    />
                                </button>

                                <button
                                    type="button"
                                    className="vd-mobile-composer-icon vd-mobile-composer-emoji"
                                    onClick={() => {

                                        setShowEmojiPicker(
                                            current =>
                                                !current
                                        );

                                    }}
                                    disabled={
                                        sending ||
                                        sendingFile
                                    }
                                    style={{
                                        width:
                                            40,
                                        height:
                                            40,
                                        border:
                                            "none",
                                        borderRadius:
                                            13,
                                        background:
                                            showEmojiPicker
                                                ?
                                                "#dbeafe"
                                                :
                                                "#f1f5f9",
                                        color:
                                            "#475569",
                                        display:
                                            "flex",
                                        alignItems:
                                            "center",
                                        justifyContent:
                                            "center",
                                        flexShrink:
                                            0
                                    }}
                                >
                                    <Smile
                                        size={19}
                                        strokeWidth={2}
                                    />
                                </button>

                                <input
                                    type="text"
                                    value={
                                        newMessage
                                    }
                                    onChange={
                                        event =>
                                            setNewMessage(
                                                event.target.value
                                            )
                                    }
                                    onKeyDown={
                                        event => {

                                            if (
                                                event.key ===
                                                    "Enter" &&
                                                !event.shiftKey
                                            ) {

                                                event.preventDefault();

                                                handleSendMessage();

                                            }

                                        }
                                    }
                                    placeholder={
                                        "Escribe un mensaje..."
                                    }
                                    disabled={
                                        sending ||
                                        sendingFile
                                    }
                                    style={{
                                        flex:
                                            1,
                                        minWidth:
                                            0,
                                        height:
                                            44,
                                        border:
                                            "none",
                                        outline:
                                            "none",
                                        background:
                                            "#f1f5f9",
                                        borderRadius:
                                            15,
                                        padding:
                                            "0 12px",
                                        fontSize:
                                            15,
                                        color:
                                            "#0f172a",
                                        boxSizing:
                                            "border-box"
                                    }}
                                />

                                {
                                    newMessage.trim()
                                        ?
                                        (
                                            <button
                                                type="button"
                                                className="vd-mobile-composer-send"
                                                onClick={
                                                    handleSendMessage
                                                }
                                                aria-label="Enviar mensaje"
                                                disabled={
                                                    sending
                                                }
                                                style={{
                                                    width:
                                                        44,
                                                    height:
                                                        44,
                                                    border:
                                                        "none",
                                                    borderRadius:
                                                        15,
                                                    background:
                                                        sending
                                                            ?
                                                            "#cbd5e1"
                                                            :
                                                            "#2563eb",
                                                    color:
                                                        "#fff",
                                                    display:
                                                        "flex",
                                                    alignItems:
                                                        "center",
                                                    justifyContent:
                                                        "center",
                                                    flexShrink:
                                                        0
                                                }}
                                            >
                                                {
                                                    sending
                                                        ?
                                                        (
                                                            <LoaderCircle
                                                                size={18}
                                                                style={{
                                                                    animation:
                                                                        "spin 1s linear infinite"
                                                                }}
                                                            />
                                                        )
                                                        :
                                                        (
                                                            <Send
                                                                size={19}
                                                                strokeWidth={2}
                                                            />
                                                        )
                                                }
                                            </button>
                                        )
                                        :
                                        (
                                            <button
                                                type="button"
                                                className="vd-mobile-composer-mic"
                                                onClick={
                                                    iniciarGrabacion
                                                }
                                                aria-label="Iniciar grabación"
                                                disabled={
                                                    sending ||
                                                    sendingFile
                                                }
                                                style={{
                                                    width:
                                                        44,
                                                    height:
                                                        44,
                                                    border:
                                                        "none",
                                                    borderRadius:
                                                        15,
                                                    background:
                                                        "#2563eb",
                                                    color:
                                                        "#ffffff",
                                                    display:
                                                        "flex",
                                                    alignItems:
                                                        "center",
                                                    justifyContent:
                                                        "center",
                                                    flexShrink:
                                                        0
                                                }}
                                            >
                                                <Mic
                                                    size={19}
                                                    strokeWidth={2}
                                                />
                                            </button>
                                        )
                                }

                            </>
                        )
            }

        </div>

        <style>
            {`
                @keyframes spin {
                    from {
                        transform: rotate(0deg);
                    }
                    to {
                        transform: rotate(360deg);
                    }
                }
            `}
        </style>

    </div>

);

}
